if ( objects.is_front_page) {

    // const titre = new SplitText(".hero-title", { type: "words,chars" }),
    // charsTitre = titre.chars; //an array of all the divs that wrap each character

    // gsap.fromTo(charsTitre, {
    //     scale: 0,
    //     opacity:0,
    //     ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    // }, {
    //     opacity:1,
    //     scale: 1,
    //     stagger: 0.01,
    //     delay: 1,
    //     duration: 0.5,
    //     scrollTrigger: {
    //     trigger: "#hero",
    //     },
    // });

    var split = new SplitText(".hero-title", {type: "chars,words" });
    gsap.from(split.chars, {
        duration: 1,
        scale: 0,
        stagger: 0.01,
        scrollTrigger: {
        trigger: "#hero",
        },
    });

    gsap.from ( ".gros-logo img", {
        autoAlpha: 0,
        rotate:150,
        scale: 0,
        delay: 0.2,
        duration: 1,
    });

    // Les éléments décoratifs sont désactivables depuis le back-office :
    // on n'anime que ceux présents dans le DOM (pas de warning GSAP).
    if (document.querySelector(".persos-01")) {
        gsap.from ( ".persos-01", {
            marginRight: 500,
            autoAlpha: 0,
            scale: 1,
            delay: 0.2,
            duration: 2,
        });
    }

    if (document.querySelector(".persos-02")) {
        gsap.from ( ".persos-02", {
            marginRight: 500,
            autoAlpha: 0,
            scale: 1,
            delay: 0.2,
            duration: 2,
        });
    }

    gsap.from ( ".hero-title", {
        autoAlpha: 0,
        duration: 0,
    });


    if (document.querySelector(".portail-01")) {
        gsap.from ( ".portail-01", {
            autoAlpha: 0,
            delay: 0.5,
            duration: 1,
        });
    }

    gsap.from ( ".hero-cta, .hero-accroche", {
        autoAlpha: 0,
        opacity: 0,
        delay: 1.3,
        duration: 2,
    });

    if (!document.querySelector(".hero-bg img")) {
        // Pas d'image de fond configurée (champ ACF vide) : rien à animer.
    } else if (window.innerWidth <= 767) {
        // Animation pour les smartphones
        gsap.fromTo(".hero-bg img", {
            autoAlpha: 0,
            "-webkit-mask-image": "radial-gradient(ellipse 50% 50% at 50% 50%,#000 20%,transparent 50%)",
            "mask-image": "radial-gradient(ellipse 50% 50% at 50% 50%,#000 20%,transparent 50%)"
        }, {
            "-webkit-mask-image": "radial-gradient(ellipse 80% 100% at 50% 50%, black 20%, transparent 50%)",
            "mask-image": "radial-gradient(ellipse 80% 100% at 50% 50%, black 20%, transparent 50%)",
            autoAlpha: 1,
            duration: 1
        });
    } else {
        // Animation pour les écrans plus larges
        gsap.fromTo(".hero-bg img", {
            autoAlpha: 0,
            "-webkit-mask-image": "radial-gradient(ellipse 0% 0% at 50% 50%,#000 20%,transparent 50%)",
            "mask-image": "radial-gradient(ellipse 0% 0% at 50% 50%,#000 20%,transparent 50%)"
        }, {
            "-webkit-mask-image": "radial-gradient(ellipse 80% 100% at 50% 50%, black 20%, transparent 50%)",
            "mask-image": "radial-gradient(ellipse 80% 100% at 50% 50%, black 20%, transparent 50%)",
            autoAlpha: 1, 
            duration: 1
        });
    }


// Variable pour suivre si le gros-logo a été cliqué
var isGrosLogoClicked = false;

function handleMouseMove(event) {
    var mouseX = event.clientX;
    var mouseY = event.clientY;
    var elements = document.querySelectorAll(".perso, .gros-logo");

    elements.forEach(function(element) {
        var rect = element.getBoundingClientRect();
        var elementX = rect.left + rect.width / 2;
        var elementY = rect.top + rect.height / 2;
        var distanceX = mouseX - elementX;
        var distanceY = mouseY - elementY;
        var moveX = distanceX / 50;
        var moveY = distanceY / 50;

        if (element.classList.contains('perso')) {
            gsap.to(element, {
                duration: 0.5,
                x: moveX,
                y: moveY,
                ease: "power1.out"
            });
        } else if (element.classList.contains('gros-logo') && !isGrosLogoClicked) {
            gsap.to(element, {
                duration: 0.5,
                rotate: (moveY * 2) - (moveX * 2),
                x: (moveX * 2),
                y: (moveY * 2),
                ease: "power1.out"
            });
        }
    });
}

function handleClick() {
    // Mettre à jour la variable pour indiquer que gros-logo a été cliqué
    isGrosLogoClicked = true;
    
    // Animer .gros-logo pour qu'il tombe
    gsap.to(this, {
        y: 2000,
        rotate: 160,
        ease: "power1.out",
        duration: 3,
    });

    // Après 3 secondes, faire revenir .gros-logo depuis le haut de la fenêtre
    setTimeout(() => {
        gsap.fromTo(this, {
            y: -1000, // Position de départ en dehors du haut de la fenêtre
            rotate: 160
        }, {
            y: 0, // Position finale (position initiale)
            rotate: 0,
            ease: "power1.out",
            duration: 3,
            onComplete: () => {
                // Réinitialiser isGrosLogoClicked une fois l'animation terminée
                isGrosLogoClicked = false;
            }
        });
    }, 1500); // 3000 ms = 3 s
}

document.addEventListener("mousemove", handleMouseMove);
document.querySelector(".gros-logo").addEventListener("click", handleClick);


    
}